import { RoutesList } from '../../../config/routes-list';
import {
  DEFAULT_CONSULTANT_DEADLINES_FILTERS,
  serializeConsultantDeadlinesFilters,
} from './deadline-url-filters';

/** Query param that asks the calendar to highlight one deadline once. */
export const DEADLINE_HIGHLIGHT_PARAM = 'highlight';

/**
 * Week view on the due day with the deadline highlighted once (the calendar drops the
 * param). Starts from the default filters: a narrowing left on the page could hide it.
 */
export function buildDeadlineCalendarLink(target: { deadlineId: string; dueAt: string }): string {
  const params = serializeConsultantDeadlinesFilters({
    ...DEFAULT_CONSULTANT_DEADLINES_FILTERS,
    view: 'calendar',
    calendarView: 'week',
    day: target.dueAt.slice(0, 10),
  });
  params.set(DEADLINE_HIGHLIGHT_PARAM, target.deadlineId);
  return `${RoutesList.CONSULTANT_DEADLINES}?${params.toString()}`;
}
